<div id="<%= dom_id level %>" class="w-full sm:w-auto my-5 space-y-5">
  <div>
    <strong class="block font-medium mb-1">Name:</strong>
    <%= level.name %>
  </div>
</div>
